import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const IMG = "https://images.unsplash.com/photo-1775144657626-29ff0a46ca90";
const ease = [0.22, 1, 0.36, 1];

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/portal");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  const field = "w-full bg-transparent border-b border-border px-0 py-3 text-bone placeholder:text-bone/30 outline-none focus:border-gold transition-colors duration-300";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-ink">
      <div className="hidden lg:block relative">
        <img src={IMG} alt="Office" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-ink/50" />
        <div className="absolute bottom-16 left-12 right-12">
          <div className="serif text-4xl text-bone font-light leading-tight">Your legacy,<br />securely in reach.</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease }} className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-bone/50 hover:text-bone overline mb-12 transition-colors duration-300"><ArrowLeft size={16} /> Home</Link>
          <div className="serif text-2xl text-bone mb-1">Legacy<span className="text-gold">.</span></div>
          <h1 className="serif font-light text-4xl text-bone tracking-tighter mb-10">Client Portal</h1>
          <form onSubmit={submit} data-testid="login-form" className="space-y-8">
            <input required type="email" data-testid="login-email" placeholder="Email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
            <input required type="password" data-testid="login-password" placeholder="Password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
            <button disabled={loading} data-testid="login-submit" className="w-full py-4 bg-gold text-ink overline hover:bg-bone transition-colors duration-300 disabled:opacity-50">{loading ? "Signing in…" : "Sign In"}</button>
          </form>
          <p className="mt-8 text-bone/50 text-sm">New client? <Link to="/register" data-testid="to-register" className="text-gold link-underline">Create an account</Link></p>
        </motion.div>
      </div>
    </div>
  );
}
